import bem from 'utils/bem';

export const block = bem('update-email-modal');
